import { Apis } from "../../lib/Apis";

export const useDeliveryManagement = () => {
    const getInStationZones = async (setZoneData, offset = 0, limit = 9) => {
        try {
            const response = await Apis.getAllInStationZone(offset, limit);
            setZoneData(response.data.data);
            return response.data;
        } catch (error) {
            console.error('Error fetching zones:', error);
            throw error;
        }
    };
    const getOutStationZones = async (setZoneData, offset = 0, limit = 9) => {
        try {
            const response = await Apis.getAllZone(offset, limit);
            setZoneData(response.data.zones);
            return response.data;
        } catch (error) {
            console.error('Error fetching zones:', error);
            throw error;
        }
    };
    const getAllInStationZones = async (setAllZoneData) => {
        try {
            const response = await Apis.getAllInStationZones();
            setAllZoneData(response.data.instationZones);
            return response.data;
        } catch (error) {
            console.error('Error fetching zone:', error);
            throw error;
        }
    };
    const getAllOutStationZones = async (setAllZoneData) => {
        try {
            const response = await Apis.getZones();
            setAllZoneData(response.data.zones);
            return response.data;
        } catch (error) {
            console.error('Error fetching zone:', error);
            throw error;
        }
    };
    const getAllInStationBaseRates = async (setAllInStationBaseRatesData) => {
        try {
            const response = await Apis.getAllInStation();
            setAllInStationBaseRatesData(response.data.inStationBaseRates);
            return response.data;
        } catch (error) {
            console.error('Error fetching in station base rates:', error);
            throw error;
        }
    };
    const addInStationZone = async (data) => {
        try {
            const response = await Apis.createInStationZone(data);
            return response;
        } catch (error) {
            console.error('Error creating zone:', error);
            throw new Error('Failed to add zone');
        }
    };
    const addOutStationZone = async (data) => {
        try {
            const response = await Apis.createZone(data);
            return response;
        } catch (error) {
            console.error('Error creating zone:', error);
            throw error; // Pass through the original error to preserve backend message
        }
    };
    const updateInStationZone = async (id, data) => {
        try {
            const response = await Apis.updateInStationZone(id, data);
            return response;
        } catch (error) {
            console.error(error);
            throw new Error('Failed to update zone');
        }
    };
    const updateOutStationZone = async (id, data) => {
        try {
            const response = await Apis.updateZone(id, data);
            return response;
        } catch (error) {
            console.error(error);
            throw error; // Pass through the original error to preserve backend message
        }
    };
    const deleteInStationZone = async (id) => {
        try {
            const response = await Apis.deleteInStationZone(id);
            return response;
        } catch (error) {
            console.error(error);
            throw new Error('Failed to delete zone');
        }
    };
    const deleteOutStationZone = async (id) => {
        try {
            const response = await Apis.deleteZone(id);
            return response;
        } catch (error) {
            console.error(error);
            throw new Error('Failed to delete zone');
        }
    };
    const addCities = async (data) => {
        try {
            const response = await Apis.createCity(data);
            return response;
        } catch (error) {
            console.error(error);
            throw new Error('Failed to add city');
        }
    };
    const getCities = async (setCities, offset = 0, limit = 9) => {
        try {
            const response = await Apis.getCities(offset, limit);
            setCities(response.data.data);
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
    const deleteCity = async (id) => {
        try {
            const response = await Apis.deleteCity(id);
            return response;
        } catch (error) {
            console.error(error);
            throw new Error('Failed to delete city');
        }
    };
    const updateCity = (id, data) => {
        try {
            const response = Apis.updateCityStatus(id, data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
    const getInStationBaseRates = async (setInStationBaseRatesData, offset = 0, limit = 9) => {
        try {
            const response = await Apis.getAllInStation(offset, limit);
            setInStationBaseRatesData(response.data.inStationBaseRates || []);
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
    const getOutStationBaseRates = async (setOutStationBaseRatesData, offset = 0, limit = 9) => {
        try {
            const response = await Apis.getAllOutStationBaseRates(offset, limit);
            setOutStationBaseRatesData(response.data.outStationBaseRates || []);
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
    const addInStationBaseRate = async (data) => {
        try {
            const response = await Apis.createInStationBaseRate(data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        };
    }
    const addOutStationBaseRate = async (data) => {
        try {
            const response = await Apis.createOutStationBaseRate(data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
    const updateInStationBaseRate = async (id, data) => {
        try {
            const response = await Apis.updateInStationBaseRate(id, data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
    const updateOutStationBaseRate = async (id, data) => {
        try {
            const response = await Apis.updateOutStationBaseRate(id, data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
    const deleteInStationBaseRate = async (id) => {
        try {
            const response = await Apis.deleteInStationBaseRate(id);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    const deleteOutStationBaseRate = async (id) => {
        try {
            const response = await Apis.deleteOutStationBaseRate(id);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    return {
        addCities,
        getCities,
        updateCity,
        deleteCity,
        getInStationZones,
        getAllInStationZones,
        addInStationZone,
        updateInStationZone,
        deleteInStationZone,
        getOutStationZones,
        getAllOutStationZones,
        addOutStationZone,
        updateOutStationZone,
        deleteOutStationZone,
        getInStationBaseRates,
        getOutStationBaseRates,
        addInStationBaseRate,
        addOutStationBaseRate,
        updateInStationBaseRate,
        updateOutStationBaseRate,
        deleteInStationBaseRate,
        deleteOutStationBaseRate,
        getAllInStationBaseRates
    };
};